<template>
  <div id="dashboard_page" class="centered" v-if="loaded">

    <div class="col-md-6">
      <div id="user_welcome">
        <span>ברוך הבא,</span>
        <h3 v-text="get_me().display_name"></h3>
        <label>{{(get_me().type == 'artist' ? 'אמן' : 'איש מדיה')}}</label>
        <div class="pic_wrapper"  :style="'background-image:linear-gradient(90deg, rgba(0,0,0,0.16290266106442575) 0%, rgba(0,0,0,0) 25%, rgba(0,0,0,0.5046393557422969) 100%),url('+get_me().pic_parsed+')'">
          <div class="fade_pic"></div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="user_props">
        <div class="prop">
          <i :style="'background-image:url(' + ico_num_artists + ')'"></i>
          <div class="texts">
            <span v-text="items.length"></span>
            <label>לינקטונים</label>
          </div>
        </div>

        <div class="prop">
          <i :style="'background-image:url(' + ico_views + ')'"></i>
          <div class="texts">
            <span v-text="format_number(total_views)"></span>
            <label>סך כל ההאזנות</label>
          </div>
        </div>

        <div class="prop">
          <i :style="'background-image:url(' + ico_lpedia_views + ')'"></i>
          <div class="texts">
            <span v-text="format_number(num_lpedia)"></span>
            <label>צפיות בלינקיפדיה</label>
          </div>
        </div>
      </div>

    </div>

    <div class="clr"></div>

    <div class="col-md-6">

      <div class="col-md-12">
        <div class="">
           
             <div class="col-md-12">
                  <div class="box">
                      <h4>כניסות ללינקטונים שלי</h4>
                     <LineChart :x="false" :y="true" :data="chartdata" :options="options" :legend="false" legend_label="צפיות בלינקטונים שלי" />
                  </div>
              </div>
              <div class="col-md-6">
                <div id="banner"></div>
              </div>
              <div class="col-md-6">
                  <div class="box">
                        <h4>התחנות שצפו בי הכי הרבה</h4>
                         <PieChart :data="piechartdata" :options="{}"></PieChart>

                  </div>
              </div>
              <div class="clr"></div>
          </div>
        </div>
    </div>
    <div class="col-md-6">
      <!-- <div v-if="artists.length > 1">
          <h3>האומנים שלי</h3>
          <ArtistItem v-for="artist in artists" :key="artist.id" :item="artist" />
          <div class="clr" style="margin-bottom:40px"></div>
      </div> -->

      <div v-if="show_linktones" id="linktones_list">
          <h3>הלינקטונים שלי</h3>
          <div class="clr"></div>

    <div id="items_table"><div class="item"  v-for="item in items" :key="item.id" >
        <span class="num">{{item.total_views}} <p>האזנות</p></span>
        <div class="pic" :style="'background-image:url(' + item.pic_tumb + ')'" @click="$emit('open_widget', item)"></div>
        <div class="texts">
            <h4 v-text="item.name"></h4>
        </div>
         <span class="date" v-text="item.online_date_format"></span>
        <div class="option" @click="$emit('open_widget', item)"><img src="@/assets/to_lt.svg" style="height:35px;"></div>
        <router-link :to="'/stats/' + item.id" class="option" @click="$emit('itemOpen')" style="color:#000"><i class="fas fa-chart-line"></i></router-link>
      </div>
      <div class="clr"></div>
    </div> 
      </div>
      
    </div>

  </div>
</template>

<script>
import LineChart from '@/components/new_charts/LineChart.vue';
import PieChart from '@/components/charts/PieChart.vue';
//import ArtistItem from '@/components/catalog/artist_item.vue'; 

export default {
    components: {  LineChart, PieChart, /*ArtistItem*/},
  data(){
    return {
      artist_id: (this.$route.params.id > 0 ? this.$route.params.id : ''),
      loaded: false,
      ico_num_artists: require('@/assets/ico_num_artists.svg'),
      ico_views: require('@/assets/ico_views.svg'),
      ico_lpedia_views: require('@/assets/ico_lpedia_views.svg'),
      
      artists: [],
      num_lpedia: 0,
      total_views: 0,

      has_artists: false,
      show_linktones: true,
      items: [
      ],
      
      options: {
      responsive: true,
      maintainAspectRatio: false,
        legend: {
            display: false
        },

      },
      chartdata: {
        labels: ['January', 'February'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979', 
            data: [40, 20]
          }
        ]
      },
      piechartdata: {
            labels: ['sdf', 'sdf', 'dfgfdgdfg'],
            datasets: [
                {
                    fill: true,
                    backgroundColor:  this.$store.color_array,
                    data: [5, 95, 20],
        // Notice the borderColor 
                    borderColor: this.$store.border_array,
                    borderWidth: [1,1]
                }
            ]
          },

      
    }
  },

  mounted(){
    this.api({ action: 'dashboard', data: { artist_id: this.artist_id, order: 'id DESC' } }, (data) => { 
      
      this.num_lpedia = data.data.num_lpedia;
      this.items = data.data.items;
      this.artists = data.data.artists;
      this.total_views = data.data.total_views;
      this.chartdata.labels = Object.values(data.data.views).map(function(rows) { return rows.date_key});
      this.chartdata.datasets[0].data = Object.values(data.data.views).map(function(rows) { return parseInt(rows.value); });
      this.piechartdata.labels = Object.values(data.data.topStationsPie).map(function(rows) { return rows.name});
      this.piechartdata.datasets[0].data = Object.values(data.data.topStationsPie).map(function(rows) { return parseInt(rows.num); });

      this.loaded = true;
    });
  }
  
}
</script>

<style scoped lang="scss">

#linktones_list{
  h3{font-size: 22px;margin-bottom: 20px;}
  #items_table{
  .item{
    svg{color: rgba(0, 0, 0, 0.5);}
    &{margin-bottom: 20px;}
    .num{font-size: 50px;}
    .texts{padding: 0;}
    .option{width: 7%;padding-top: 20px;}
    .date{padding: 25px 0;}
  }
}
}
.col-md-12{padding: 0;}
#banner{height: 325px; background:  #a30303 ;width: 100%;border-radius: 10px;}
.box{box-shadow: 0 7px 17px 0 rgba(88, 91, 111, 0.08); background-color: #f4f4f4;border-radius: 10px;padding: 10px 20px;    margin-bottom: 25px;}
.box h4{color: #1e212a; font-size: 22px; font-family: "almoni-dl", "Assistant", sans-serif; padding: 10px}
.pic_wrapper{position: absolute;left: 0px;height: 145px; background-size: contain;width: 200px;background-repeat: no-repeat;top: 0;border-radius: 10px 0 0 10px}
.pic_wrapper .fade_pic{height: 100%;width: 100%;background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.31416316526610644) 50%, rgba(0,0,0,1) 100%);
}
#dashboard_page
{

  #user_welcome { height: 145px; background: #000; padding: 25px 40px; line-height: 0.9; border-radius: 10px; margin-bottom: 25px;position: relative;
    span {   font-size: 33px; font-weight: 900; color: #ff005e;}
    h3 {  font-size: 39px; color: #fff; font-weight: normal; }
      label { display: block; font-size: 23px; color:rgba(255,255,255,0.6);}
  }
  
  .user_props {
    & { display: flex; margin-top: 40px; }
    .prop { flex:1 0 auto; padding-left: 20px;
      i { float: right; background: top center no-repeat; background-size:contain; width:60px; height: 60px; margin-left: 10px;}
      .texts {float: right; line-height: normal;}
      span { display: block; font-size: 50px; font-weight: bold; margin-top: -15px; }
      label { display: block; font-size: 20px; color:rgba(0,0,0,0.7);}
    }
  }

  .graph_chart { background: #eee; padding:25px; text-align: center; font-weight: bold; border:1px solid #aaa; margin-bottom: 25px; }
}


.item{
  .share{display: flex;padding: 25px;}
  .share{
    .icon{margin: 0 10px;font-size: 14px;border: 1px solid;padding: 0px;border-radius: 100%;line-height: 1px;cursor: pointer; width:30px; height: 30px; text-align: center; line-height: 30px;}
    .icon:hover{transform: scale(1.04);}
  }
  .texts{
    h4{color: #000 !important;padding-top: 25px;padding-right: 25px;}
  }
.num{
  &{    font-size: 51px;padding-top: 19px;color: #ff1661 !important;}
  p{    font-size: 17px; margin-top: 4px;}
}
.active{color: #ff1661;}
.option{
  &{text-align: center;padding-top: 9px;width: 10%;cursor: pointer;font-size: 16px;font-weight: 700;}
  .svg-inline--fa{    font-size: 35px;text-align: center;margin-bottom: -3px;}
}
}

</style>